import { makeStyles } from '@material-ui/styles';



const formDisposition : any = {
    display: 'flex',
    flexDirection: 'column'
}

export default makeStyles({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    modalBody: {
        ...formDisposition,
        backgroundColor: 'white',
        padding: 40
    },

    modalTitle: {
        marginBottom: '3rem'
    },

    modalForm: {
        ...formDisposition,
        height: 260
    },

    modalTextField: {
        height: 80,
        marginBottom: '2rem'
    }
});